<template>
  <AppBanner>
    Edit User
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader />
  </template>

  <template v-else-if="!user">
    <h1 class="flex items-center justify-center h-full">
      Unable to load user. Please try again.
    </h1>
  </template>

  <template v-else>
    <UserForm :model="user" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { UserForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const user = ref(null);

const loadUser = async () => {
  const response = await useHttp().get(`/users/${route.params.user}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    user.value = response.data;
  }

  loading.value = false;
};

loadUser();
</script>
